import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-add-balance',
  templateUrl: './add-balance.page.html',
  styleUrls: ['./add-balance.page.scss'],
})
export class AddBalancePage implements OnInit {
  selected = 0;
  otherAmount: boolean;

  constructor(private dataService: DataService, private router: Router, private alertCtrl: AlertController) {}

  ngOnInit() {
    this.otherAmount = false;
  }

  select(amount) {
    this.selected = amount;
    this.otherAmount = false;
  }

  async enterOtherAmount() {
    this.otherAmount = true;
    const alert = await this.alertCtrl.create({
      header: 'Ingresar monto',
      inputs: [
        {
          name: 'amount',
          type: 'tel',
          placeholder: '$0',
          value: this.selected,
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          },
        },
        {
          text: 'Ok',
          handler: (value) => {
            const amount = +value.amount;
            this.selected = amount >= 50 ? amount : 50;
          },
        },
      ],
    });

    await alert.present();
  }

  goPayment() {
    this.dataService.setData('payment-amount', this.selected);
    this.router.navigate(['/tecservice-transportec/wallet/balance/payment-method']);
  }
}
